import { render, staticRenderFns } from "./ObservationsForm_48.vue?vue&type=template&id=1dff50b9&scoped=true"
import script from "./ObservationsForm_48.ts?vue&type=script&lang=ts&external"
export * from "./ObservationsForm_48.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff50b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dff50b9')) {
      api.createRecord('1dff50b9', component.options)
    } else {
      api.reload('1dff50b9', component.options)
    }
    module.hot.accept("./ObservationsForm_48.vue?vue&type=template&id=1dff50b9&scoped=true", function () {
      api.rerender('1dff50b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ObservationsForm_48/ObservationsForm_48.vue"
export default component.exports